import React from "react";
import styled from "styled-components";

const SharedLabelWrapper = styled.span`
    cursor: pointer;
`;

const Short = styled.span`

    display: none;
    
    ${(props) => (props.open ? {
        'display': 'block'
    } : '')}
`;

const Full = styled.span`

    display: none;
    
    ${(props) => (props.open ? {
        'display': 'block'
    } : '')}
`;

export default class SharedLabel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active_label: 1
        }
    }
    toggleActive() {
        console.log('toggling!');
        console.log(this.state.active_label);
        console.log(this.state.active_label == 1 ? 2 : 1);
        this.setState({active_label: this.state.active_label == 1 ? 2 : 1});
    }
    render() {
        return (
            <>
                <SharedLabelWrapper onClick={() => {this.toggleActive();}}>
                    <Short open={this.state.active_label == 1}>{this.props.short}</Short>
                    <Full open={this.state.active_label == 2}>{this.props.full}</Full>
                </SharedLabelWrapper>
            </>
        )
    }
}